module.exports = __webpack_public_path__ + "img/vendingMachineBg.073db102.png";